import React from '@root/vendor/react';

const ExperienceDispatchContext = React.createContext();

export default ExperienceDispatchContext;
